import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from '../ApiEvs.service';

@Injectable()
export class AdminAccountService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/admin/settings/accounts', query);
  }
  create(body: any) {
    return this.post('/v2/admin/settings/account', body);
  }
  update(id, body) {
    return this.put('/v2/admin/settings/account/' + id, body);
  }
  active(id, body) {
    return this.put('/v2/admin/settings/account/active/' + id, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/admins/account.service.ts